// extracted by mini-css-extract-plugin
export default {"connectLayout":"connect_connectLayout__018PU","arrowBack":"connect_arrowBack__aPpGA"};